import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "7",
  height: "11",
  viewBox: "0 0 7 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.14919 0.861339L0.704745 5.10376C0.476152 5.32196 0.476152 5.67842 0.704745 5.89663L5.14919 10.1391C5.37428 10.3539 5.73677 10.3539 5.96186 10.1391C6.19045 9.92085 6.19045 9.56439 5.96186 9.34619L1.93272 5.50019L5.96186 1.6542C6.19045 1.436 6.19045 1.07954 5.96186 0.861339C5.73677 0.646481 5.37428 0.646481 5.14919 0.861339Z",
  fill: "#B2C0CD"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }